import { MaxButton } from "pages/Pool/styleds";
import { Text } from "rebass";
import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  padding: 20px;
  min-width: 460px;

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToExtraSmall`
    min-width: 340px;
  `};
`;

export const SmallMaxButton = styled(MaxButton)<{ width?: string }>`
  font-size: 12px;
  width: ${({ width }) => width ?? "100%"};
`;

export const ResponsiveHeaderText = styled(Text)`
  font-size: 40px;
  font-weight: 500;
  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToExtraSmall`
     font-size: 24px
  `};
`;
